// frontend/src/utils/para.js
// Türkçe ondalık (virgül) + binlik (nokta) destekli tutar parse/format.
// Nokta-binlik kuralı (virgülsüz girişlerde):
//   - Virgül varsa: virgül ondalık, noktalar binliktir ("1.250,50" → 1250.5).
//   - Virgül yoksa ve string saf binlik gruplama desenine uyuyorsa
//     (^\d{1,3}(\.\d{3})+$, örn "2.500" / "1.250.500") noktalar binlik kabul edilir
//     ve atılır → 2500 / 1250500. (TR kullanıcısı noktayı binlik ayracı olarak yazar.)
//   - Diğer virgülsüz hâllerde nokta ondalık kalır ("1250.50" → 1250.5, "1.5" → 1.5).

export function parseTutarTR(input) {
  if (input === null || input === undefined) return null;
  // Zaten sayıysa olduğu gibi döndür (idempotent). Binlik-nokta heuristiği
  // yalnız insan-yazımı STRING içindir; bir sayıyı String'e çevirip yeniden
  // parse etmek "49.505" gibi değerleri 49505'e (×1000) bozar (çift-parse).
  if (typeof input === 'number') return Number.isFinite(input) ? input : null;
  let s = String(input).trim();
  if (!s) return null;
  s = s.replace(/[₺\s]/g, '').replace(/tl/gi, '');
  if (s.includes(',')) {
    s = s.replace(/\./g, '').replace(',', '.');
  } else if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
    // Saf binlik gruplama: noktalar binlik ayracı → at.
    s = s.replace(/\./g, '');
  }
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : null;
}

export function formatTutarTR(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '';
  return Number(value).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
